import request from './request'
export const commonApi = {
  // 上传图片
  upload: (data) => request.post('/common/upload', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  /**
   * 获取下载列表
   * @returns 
   */
  getDownloadList: (params) => request.get('/information/getList',{params}),
  /**
   * 获取二级分类
   * @returns 
   */
  getTwoLevelCate: (params) => request.get('/goods/category/twolevel',{params}),
}
// 首页相关接口
export const homeApi = {
  // 获取config
  getConfig: () => request.get('/index/config'),
  // 获取首页数据
  getIndex: () => request.get('/index/home'),
}
export const shopApi = {
  /**
   * 获取分类
   * @returns 
   */
  getCate: () => request.get('/goods/goods/getCategory'),
  /**
   * 获取关联分类商品
   * @param {category_id} params 
   * @returns 
   */
  getAssociationCategoryGoods: (params) => request.get('/goods/goods/getAssociationCategoryGoods',{params}),
  /**
   * 获取商品列表
   * @param {page,category_id} params 
   * @returns 
   */
  getGoods: (params) => request.get('/goods/goods/list',{params}),

  searchGoods: (params) => request.get('/search/goods',{params}),
  /**
   * 获取积分商城商品
   * @returns 
   */
  getScoreRecommendGoods: () => request.get('/scoreshop/index/getRecommendGoods'),
  /**
   * 获取推荐商品
   * @returns 
   */
  getRecommendGoods: () => request.get('/goods/goods/getRecommendGoods'),
  /**
   * 提醒发货
   * @param {order_no} data 
   * @returns 
   */
  remindDelivery: (params) => request.get('/order/order/remindDelivery',{params}),
  /**
   * 获取商品详情
   * @param {id} params 
   * @returns 
   */
  getGoodsDetail: (params) => request.get('/goods/goods/detail',{params}),

  /**
   * 获取二级分类下商品
   * @param {id} params 
   */
  getGoodsList: (params) => request.get('/goods/category/getGoodsList',{params}),
  /**
   * 获取商品规格
   * @param {id,type} params 
   * @returns 
   */
  getGoodsSpec: (params) => request.get('/goods/goods/spec',{params}),
  /**
   * 添加购物车
   * @param {sku_id,goods_id,total} data 
   * @returns 
   */
  addCart: (data) => request.post('/user/cart/add',data),
  /**
   * 编辑购物车
   * @param {cart_id,total} data 
   * @returns 
   */
  editCart: (data) => request.post('/user/cart/edit',data),
  /**
   * 删除购物车
   * @param {cart_ids} data 
   * @returns 
   */
  delCart: (data) => request.post('/user/cart/del',data),
  /**
   * 检查购物车
   * @param {goods_id} data 
   * @returns 
   */
  
  getOrderCheck: (data) => request.post('/order/order/check',data),
  /**
   * 获取购物车
   * @returns 
   */
  getCart: () => request.get('/user/cart/index'),
  /**
   * 订单数量统计
   * @returns 
   */
  getOrderCount: () => request.get('/order/order/orderCount'),

  /**
   * 获取用户优惠券列表
   * @returns 
   */
  getUserCouponList: (params) => request.get('/sale/coupon/getUserCouponList',{params}),
  /**
   * 确认订单
   * @param {
   * goods_id,
   * total,
   * cart_id,
   * coupon_id,
   * sku_id,
   * delivery_method,
   * store_id
   * } data 
   * @returns 
   */
  confirmOrder: (data) => request.post('/order/order/confirm',data),
  /**
   * 提交订单
   * @param {
   *  goods_id,
   *  cart_id,
   *  address_id,
   *  coupon_id,
   *  total,
   *  remarks,
   *  sku_id,
   *  store_id,
   *  delivery_method,
   *  hexiao_realname,
   *  hexiao_mobile
   * } data 
   * @returns 
   */
  submitOrder: (data) => request.post('/order/order/submit',data),
  /**
   * 支付
   * @param {order_no,order_type,paytype} data 
   * @returns 
   */
  pay: (data) => request.post('/pay/pay',data),
  /**
   *  获取支付订单
   * @param {order_no,order_type} data 
   * @returns 
   */
  getPayOrder: (data) => request.post('/pay/order',data),
  /**
   * 获取服务订单列表
   * @param {status} data 
   * @returns 
   */
  getServeOrderList: (data) => request.post('/service/order/getList',data),
  /**
   * 获取服务订单列表统计
   * @returns 
   */
  getServeOrderIndex: () => request.post('/service/order/index'),
  /**
   * 获取订单列表统计
   * @returns 
   */
  getOrderIndex: () => request.post('/order/order/index'),
  /**
   * 获取订单列表
   * @param {status} data 
   * @returns 
   */
  getOrderList: (data) => request.post('/order/order/list',data),
  /**
   * 获取订单详情
   * @param {id} params 
   * @returns 
   */
  getOrderDetail: (params) => request.get('/order/order/detail',{params}),
  /**
   * 确认收货
   * @param {id} params 
   * @returns 
   */
  confirmDelivery: (params) => request.get('/order/order/deliveryGoods',{params}),
  /**
   * 获取评论列表
   * @param {status} params 
   * @returns 
   */
  getCommentList: (params) => request.get('/order/comment/getUserCommentList',{params}),
  /**
   * 提交评论
   * @param {data} data 
   * @returns 
   */
  postComment: (data) => request.post('/order/comment/post',data),
  /**
   * 添加咨询
   * @param {data} data 
   * @returns 
   */
  addConsultation: (data) => request.post('/service/order/submit',data),
  /**
   * 确认服务订单
   * @param {id} data 
   * @returns 
   */
  serveConfirm: (data) => request.post('/service/order/confirm',data),
  /**
   * 添加进度
   * @param {data} data 
   * @returns 
   */
  addStep: (data) => request.post('/service/order/addStep',data),
  /**
   * 获取服务订单详情
   * @param {order_id} params 
   * @returns 
   */
  getServeOrderDetail: (params) => request.get('/service/order/detail',{params}),
  /**
   * 确认完成服务订单
   * @param {order_id} params 
   * @returns 
   */
  completeServeOrder: (params) => request.get('/service/order/complete',{params}),
  /**
   * 查询物流
   * @param {id,express_no} params 
   * @returns 
   */
  queryExpressDelivery: (params) => request.get('/order/order/queryExpressDelivery',{params}),
}
const signApi = {
  /**
   * 签到数据
   * @returns 
   */
  getSign: () => request.post('/signin/signin/index'),
  /**
   * 签到
   * @returns 
   */
  signin: () => request.post('/signin/signin/signin'),
}
const userApi = {
  /**
   * 获取用户信息
   * @returns 
   */
  getUserInfo: () => request.get('/user/user/info'),
  /**
   * 注册
   * @param {data} data 
   * @returns 
   */
  register: (data) => request.post('/user/user/register', data),
  /**
   * 登录
   * @param {data} data 
   * @returns 
   */
  login: (data) => request.post('/user/user/login', data),
  /**
   * 获取地区
   * @returns 
   */
  getRegions: () => request.get('/common/getRegions'),
  /**
   * 获取地址列表
   * @returns 
   */
  getAddressList: () => request.get('/user/address/list'),
  /**
   * 编辑地址
   * @param {id,consignee,phone,region,address,is_default} data 
   * @returns 
   */
  editAddress: (data) => request.post('/user/address/edit', data),
  /**
   * 获取地址
   * @param {id} params 
   * @returns 
   */
  getAddress: (params) => request.get('/user/address/info',{params}),
  /**
   * 删除地址
   * @param {id} data 
   * @returns 
   */
  delAddress: (data) => request.post('/user/address/del', data),
  /**
   * 修改用户信息
   * @param {type:22,avatar,nickname,shenfen,workunit,email,password} data 
   * @returns 
   */
  updateUserInfo: (data) => request.post('/user/user/update', data),
  /**
   * 获取积分日志
   * @param {page,current:0全部,1收入,2支出} params 
   * @returns 
   */
  getScoreLog: (params) => request.get('/user/user/scoreLog',{params}),
  /**
   * 获取验证码
   * @param {mobile,type} data 
   * @returns 
   */
  getCode: (data) => request.post('/common/sendsms', data),
}
const postApi = {
  /**
   * 获取帖子详情
   * @param {id} params 
   * @returns 
   */
  getPostDetail: (params) => request.get('/news/article/detail',{params}),
  /**
   * 获取帖子列表
   * @param {category_id} params 
   * @returns 
   */
  getPostList: (params) => request.get('/news/article/getList',{params}),
  /**
   * 获取意见反馈栏目列表
   * @returns 
   */
  getFeedbackCategoryList: () => request.get('/feedback/feedback/getCategoryList'),
  /**
   * 提交意见反馈
   * @param {data} data 
   * @returns 
   */
  submitFeedback: (data) => request.post('/feedback/feedback/submit',data),
  /**
   * 删除意见反馈
   * @param {id} data 
   * @returns 
   */
  deleteFeedback: (data) => request.post('/feedback/feedback/delete',data),
  /**
   * 获取意见反馈列表
   * @param {page,keyword} params 
   * @returns 
   */
  getFeedbackList: (params) => request.get('/feedback/feedback/getList',{params}),
  /**
   * 获取意见反馈详情
   * @param {id} params 
   * @returns 
   */
  getFeedbackDetail: (params) => request.get('/feedback/feedback/detail',{params}),
  /**
   * 获取订单退款统计
   */
  orderRefundCount: () => request.get('/order/order/orderRefundCount'),
  /**
   * 提交退款
   */
  submitRefund: (data) => request.post('/order/order/submitRefund',data),
  /**
   * 获取订单退款详情
   * @param {order_id} params 
   * @returns 
   */
  refundDetail: (params) => request.get('/order/order/refundDetail',{params}),
}
export const api ={
  ...commonApi,
  ...homeApi,
  ...shopApi,
  ...userApi,
  ...signApi,
  ...postApi,
}
export default api
